import { render, staticRenderFns } from "./DoctorLabel.vue?vue&type=template&id=04b3f78a&scoped=true"
import script from "./DoctorLabel.vue?vue&type=script&lang=js"
export * from "./DoctorLabel.vue?vue&type=script&lang=js"
import style0 from "./DoctorLabel.vue?vue&type=style&index=0&id=04b3f78a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b3f78a",
  null
  
)

export default component.exports